const hasControlChars = (value) => {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return true;
  }

  return false;
};

export const resolveSafeRedirect = (target) => {
  if (typeof target !== "string") return null;

  const raw = target.trim();
  if (!raw || hasControlChars(raw)) return null;

  let url;
  try {
    url = new URL(raw, window.location.origin);
  } catch (e) {
    return null;
  }

  if (url.protocol !== "http:" && url.protocol !== "https:") return null;

  return url.href;
};

export default resolveSafeRedirect;
